import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/SmileyBlank.es.js";
const o = e.forwardRef((a, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...a, weights: t }));
o.displayName = "SmileyBlankIcon";
const l = o;
export {
  l as SmileyBlank,
  o as SmileyBlankIcon
};
